import { render, staticRenderFns } from "./AddNewFeatureDialog.vue?vue&type=template&id=42f7f58f"
import script from "./AddNewFeatureDialog.vue?vue&type=script&lang=js"
export * from "./AddNewFeatureDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports